class Loading {
    constructor(target) {
        this.t = target;
    }
    // open() {
    //     // jQuery('#loading').foundation('open', jQuery("#loading")); 
    // }
    build() {
        let build = ` 
        <div class="outer-loading fixed flex flex--center body-loading">
        <div class="inner-loading absolute text-center">
            <p class="text-thin text-left text-italic pt-10">LOADING</p>
        </div>
    </div>`
        jQuery(this.t).css('position', 'relative');
        return jQuery(this.t).append(build);
    }

    remove() { 
        setTimeout(() => {
            // jQuery('#loading').foundation('close', jQuery("#loading"));
            
            jQuery('.outer-loading').css('left', '100%');


            
            
            let scrollObject = {
                cursorcolor: "none",
                cursorwidth: "1px",
                autohidemode:'none',
                cursorborder:"1px solid rgba(214, 32, 39, 0.6)",
                background: "rgba(255,255,255, 0.1)",
            } 
            
            setTimeout(() => { 
                jQuery('.site-bar').addClass('site-bar--navigation');
                // jQuery(".single-racer__text").niceScroll(scrollObject);  
                jQuery('.outer-loading').remove(); 
            }, 1000);

           
        }, 1000); 
    }
   
}



let loading = new Loading('body');
// loading.open();
jQuery(document).ready(function() {
loading.remove();

});